import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/button';
import './animations';
import './carousels';
import Floaty from './floaty';
//Change nav behaviour
window.addEventListener('load', function () {
    document.querySelectorAll('.floaty').forEach(function (floatyEl) {
        new Floaty(floatyEl);
    });
    document.querySelectorAll('#theme-header .dropdown-toggle').forEach(function (link) {
        var dropdown = link.parentElement.querySelector('.dropdown-menu');
        link.addEventListener('mouseover', function () {
            link.classList.add('show');
            dropdown.classList.add('show');
        });
        link.addEventListener('mouseout', function (event) {
            if (event.relatedTarget === dropdown) {
                return;
            }
            link.classList.remove('show');
            dropdown.classList.remove('show');
        });
        dropdown.addEventListener('mouseover', function () {
            link.classList.add('show');
            dropdown.classList.add('show');
        });
        dropdown.addEventListener('mouseout', function (event) {
            if (event.relatedTarget === link) {
                return;
            }
            link.classList.remove('show');
            dropdown.classList.remove('show');
        });
        link.addEventListener('click', function () {
            window.location.href = link.href;
        });
    });
});
